/* eslint-disable arrow-body-style */
/**
 * 设置左侧菜单路径
 */

import { useMemo } from "react";
import { useSelector } from "umi";
export const useDashboardPath = () => {
  const { dataFrame } = useSelector((state: any) => {
    // 初始可能为undefied,在此加兜底
    return {
      dataFrame: state.dashboard?.currentGame?.data_frame || 'mobile',
    };
  });
  // todo 后面可能需要提单优化为根据框架类型，配置路由，当前迭代先赶迭代内需求进度，针对revenue特殊处理
  const isPc = dataFrame === 'pc';
  const pathList = useMemo(() => {
    return [
      {
        value: '/overview/daily',
        text: '/overview/daily',
        name_en: 'Daily',
        name_cn: '日报',
      },
      {
        value: '/overview/daily-v2',
        text: '/overview/daily-v2',
        name_en: 'Daily-Only Active Data',
        name_cn: '日报-仅活跃数据',
      },
      {
        value: '/overview/daily-v3',
        text: '/overview/daily-v3',
        name_en: 'Daily V3',
        name_cn: '日报 V3',
      },
      {
        value: '/overview/weekly',
        text: '/overview/weekly',
        name_en: 'Weekly',
        name_cn: '周报',
      },
      {
        value: '/overview/weekly-v2',
        text: '/overview/weekly-v2',
        name_en: 'Weekly-Only Active Data',
        name_cn: '周报-仅活跃数据',
      },
      {
        value: '/overview/monthly',
        text: '/overview/monthly',
        name_en: 'Monthly',
        name_cn: '月报',
      },
      {
        value: '/overview/monthly-v2',
        text: '/overview/monthly-v2',
        name_en: 'Monthly-Only Active Data',
        name_cn: '月报-仅活跃数据',
      },
      {
        value: '/overview/versionDaily',
        text: '/overview/versionDaily',
        name_en: 'Daily-By version',
        name_cn: '日报-分版本',
      },
      {
        value: '/overview/dataRange',
        text: '/overview/dataRange',
        name_en: 'Date Range',
        name_cn: '多天运营数据',
      },
      {
        value: '/overview/eventsDetails',
        text: '/overview/eventsDetails',
        name_en: 'eventsDetails',
        name_cn: '事件详情',
      },
      {
        value: '/overview/kpi',
        text: '/overview/kpi',
        name_en: 'KPI Overview',
        name_cn: 'KPI总览',
      },
      {
        value: '/realtime/index',
        text: '/realtime/index',
        name_en: 'Realtime',
        name_cn: '实时',
      },
      {
        value: '/realtime/users',
        text: '/realtime/users',
        name_en: 'Realtime Users',
        name_cn: '实时用户',
      },
      {
        value: '/realtime/revenue',
        text: '/realtime/revenue',
        name_en: 'Realtime Revenue',
        name_cn: '实时收入',
      },
      {
        value: '/realtime/steam',
        text: '/realtime/steam',
        name_en: 'Realtime Steam Units',
        name_cn: '实时Steam销量',
      },
      {
        value: '/realtime/sales',
        text: '/realtime/sales',
        name_en: 'Realtime Steam Sales',
        name_cn: '实时Steam销售',
      },
      {
        value: '/realtime/steamCCU',
        text: '/realtime/steamCCU',
        name_en: 'Realtime Steam CCU',
        name_cn: '实时Steam在线',
      },
      {
        value: '/retention/index',
        text: '/retention/index',
        name_en: 'Retention',
        name_cn: '留存',
      },

      {
        value: '/retention/nightingale',
        text: '/retention/nightingale',
        name_en: 'Nightgale-Retention',
        name_cn: '留存-Nightgale',
      },

      {
        value: '/engagement/active',
        text: '/engagement/active',
        name_en: 'Active',
        name_cn: '活跃',
      },
      {
        value: '/engagement/churn',
        text: '/engagement/churn',
        name_en: 'Churn',
        name_cn: '流失',
      },
      {
        value: '/engagement/return',
        text: '/engagement/return',
        name_en: 'Return',
        name_cn: '回流',
      },
      {
        value: '/engagement/register',
        text: '/engagement/register',
        name_en: 'New',
        name_cn: '新进',
      },
      {
        value: '/engagement/rollingRetention',
        text: '/engagement/rollingRetention',
        name_en: 'Rolling Retention',
        name_cn: '滚动留存',
      },
      {
        value: '/engagement/rateReturn',
        text: '/engagement/rateReturn',
        name_en: 'Return V2',
        name_cn: '回流 V2',
      },
      {
        value: '/monetization/revenue',
        text: '/monetization/revenue',
        name_en: isPc ? 'In-Game Revenue' : 'Revenue',
        name_cn: isPc ? '游戏内收入' : '付费流水',
      },
      {
        value: '/monetization/ltv',
        text: '/monetization/ltv',
        name_en: 'LTV',
        name_cn: 'LTV',
      },
      {
        value: '/monetization/adFunnel',
        text: '/monetization/adFunnel',
        name_en: 'Ad Funnel',
        name_cn: '广告漏斗',
      },
      {
        value: '/comparisonAnalysis/dateComparison',
        text: '/comparisonAnalysis/dateComparison',
        name_en: 'Date Comparison',
        name_cn: '时间对比',
      },
      {
        value: '/comparisonAnalysis/countryComparison',
        text: '/comparisonAnalysis/countryComparison',
        name_en: 'Country Comparison',
        name_cn: '国家对比',
      },
      {
        value: '/comparisonAnalysis/eventComparison',
        text: '/comparisonAnalysis/eventComparison',
        name_en: 'Event Comparison',
        name_cn: '事件对比',
      },
      {
        value: '/eventAnalysis/eventAnalysis',
        text: '/eventAnalysis/eventAnalysis',
        name_en: 'Event Analysis',
        name_cn: '事件分析',
      },
      // 按照Country上报时区
      {
        value: '/multiTimezone/dailyTimezone/country',
        text: '/multiTimezone/dailyTimezone/country',
        name_en: 'Daily by Country',
        name_cn: '分国家日报',
      },
      {
        value: '/multiTimezone/newUsers/country',
        text: '/multiTimezone/newUsers/country',
        name_en: 'Retention By Country',
        name_cn: '分国家留存',
      },
      // 按照zone上报时区
      {
        value: '/multiTimezone/dailyTimezone/zone',
        text: '/multiTimezone/dailyTimezone/zone',
        name_en: 'Daily by Zone',
        name_cn: '分区服日报',
      },
      {
        value: '/multiTimezone/newUsers/zone',
        text: '/multiTimezone/newUsers/zone',
        name_en: 'Retention By Zone',
        name_cn: '分区服留存',
      },
      {
        value: '/ua/noSpend',
        text: '/ua/noSpend',
        name_en: 'No Spend',
        name_cn: 'UA无花费',
      },
      {
        value: '/ua/spend',
        text: '/ua/spend',
        name_en: 'Spend',
        name_cn: 'UA花费',
      },
      {
        value: '/pvp/speed',
        text: '/pvp/speed',
        name_en: 'Speed',
        name_cn: '自助分析',
      },
      {
        value: '/competitor/index',
        text: '/competitor/index',
        name_en: 'Competitor',
        name_cn: '竞品对比',
      },
      {
        value: '/competitor/xh-index',
        text: '/competitor/xh-index',
        name_en: 'Competitor-excl.smurf',
        name_cn: '竞品对比-去小号',
      },
      {
        value: '/subscribe/subscribeManage',
        text: '/subscribe/subscribeManage',
        name_en: 'Subscription Management',
        name_cn: '订阅管理',
      },
      {
        value: '/subscribe/subscribeRecord',
        text: '/subscribe/subscribeRecord',
        name_en: 'Subscription Record',
        name_cn: '订阅记录',
      },
      {
        value: '/subscribe/subscribeSetting',
        text: '/subscribe/subscribeSetting',
        name_en: 'Subscription Setting',
        name_cn: '订阅设置',
      },
      {
        value: '/funnel/registerFunnel',
        text: '/funnel/registerFunnel',
        name_en: 'Register Funnel',
        name_cn: '注册漏斗',
      },
      {
        value: '/funnel/pc/registerFunnel',
        text: '/funnel/pc/registerFunnel',
        name_en: 'Register Funnel PC',
        name_cn: '注册漏斗 PC',
      },
      {
        value: '/funnel/steam/registerFunnel',
        text: '/funnel/steam/registerFunnel',
        name_en: 'Register Funnel Steam',
        name_cn: '注册漏斗 Steam',
      },
      {
        value: '/funnel/epic/registerFunnel',
        text: '/funnel/epic/registerFunnel',
        name_en: 'Register Funnel Epic',
        name_cn: '注册漏斗 Epic',
      },
      {
        value: '/funnel/ps/registerFunnel',
        text: '/funnel/ps/registerFunnel',
        name_en: 'Register Funnel PS',
        name_cn: '注册漏斗 PS',
      },
      {
        value: '/funnel/xbox/registerFunnel',
        text: '/funnel/xbox/registerFunnel',
        name_en: 'Register Funnel Xbox',
        name_cn: '注册漏斗 Xbox',
      },
      {
        value: '/funnel/registerFunnelDaily',
        text: '/funnel/registerFunnelDaily',
        name_en: 'Funnel',
        name_cn: 'Funnel',
      },
      {
        value: '/intlsdk/successRateAndErrorCode',
        text: '/intlsdk/successRateAndErrorCode',
        name_en: 'Success Rate And Error Code',
        name_cn: '成功率错误码',
      },
      {
        value: '/dashApp',
        text: '/dashApp',
        name_en: 'Dash Demo',
        name_cn: 'Dash Demo',
      },
      {
        value: '/overview/xh-daily',
        text: '/overview/xh-daily',
        name_en: 'Daily-excl.smurf',
        name_cn: '日报-去小号',
      },
      {
        value: '/overview/xh-monthly',
        text: '/overview/xh-monthly',
        name_en: 'Monthly-excl.smurf',
        name_cn: '月报-去小号',
      },
      {
        value: '/overview/acc-daily',
        text: '/overview/acc-daily',
        name_en: 'Daily-汇总版-去小号',
        name_cn: '日报-汇总版-去小号',
      },
      {
        value: '/monetization/salesOverview',
        text: '/monetization/salesOverview',
        name_en: 'Sales Overview',
        name_cn: '销售概览',
      },
      {
        value: '/monetization/salesBreakdown',
        text: '/monetization/salesBreakdown',
        name_en: 'Sales Breakdown',
        name_cn: '销售构成',
      },
      {
        value: '/monetization/inGameRevenue',
        text: '/monetization/inGameRevenue',
        name_en: 'Revenue',
        name_cn: '付费流水',
      },
      {
        value: '/monetization/inGameRevenueMerge',
        text: '/monetization/inGameRevenueMerge',
        name_en: 'Revenue Merge',
        name_cn: '付费流水合并',
      },
      {
        value: '/looker/Login-Funnel',
        text: '/looker/Login-Funnel',
        name_en: 'Login-Funnel',
        name_cn: 'Login-Funnel',
      },
      {
        value: '/looker/explore',
        text: '/looker/explore',
        name_en: 'Looker Explore',
        name_cn: 'Looker Explore',
      },
      {
        value: '/realtime/nightingaleUsers',
        text: '/realtime/nightingaleUsers',
        name_en: 'Nightgale-Realtime Users',
        name_cn: '实时用户-Nightgale',
      },
      {
        value: '/wow/index',
        text: '/wow/index',
        name_en: 'WOW核心数据看板',
        name_cn: 'WOW核心数据看板',
      },
      {
        value: '/overview/lifetime',
        text: '/overview/lifetime',
        name_en: 'Lifetime Sales',
        name_cn: '累计销售数据',
      },
      {
        value: '/benchmark/explore',
        text: '/benchmark/explore',
        name_en: 'Benchmark',
        name_cn: 'Benchmark',
      },
      {
        value: '/benchmark/gtdrAssessment',
        text: '/benchmark/gtdrAssessment',
        name_en: 'GTDR Assessment',
        name_cn: 'GTDR评估',
      },
      {
        value: '/forecast',
        text: '/forecast',
        name_en: 'Forecast',
        name_cn: '预测',
      },
      {
        value: '/report/abnormalReport',
        text: '/report/abnormalReport',
        name_en: 'AI Daily Report',
        name_cn: 'AI 异动日报',
      },
      {
        value: '/performance/overall',
        text: '/performance/overall',
        name_en: '性能监控',
        name_cn: '性能监控',
      }
    ];
  }, [dataFrame]);

  return pathList;
};
